// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Share_wrapper__3XzcH","text":"Share_text__1v_UG","link":"Share_link__3P3bP","svg":"Share_svg__1mtA8"};